<template>
    <span class="score-badge" data-testing="score-badge">
        <span v-if="isComplete" class="score-badge-complete" data-testing="score-badge-complete">
            <span class="score-badge-complete-text" data-testing="score-badge-complete-text">{{ t('SCORE_BADGE_COMPLETE_LABEL') }}</span>
            <cr-icon color="cr-splash-accent" medium data-testing="score-badge-complete-icon">bi-award-fill</cr-icon>
        </span>
        <span v-else class="score-badge-star" data-testing="score-badge-star">
            <cr-image src="/filled-star.svg" :alt="t('SCORE_BADGE_STAR_ALT', { score })" height="2rem"/>
            <span class="score-badge-score" data-testing="score-badge-score">{{ score }}</span>
        </span>
    </span>
</template>

<style scoped>
.score-badge
{
    display: inline-flex;
    align-items: center;
    min-height: 2rem;
}

.score-badge-complete
{
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
}

.score-badge-complete :deep(.cr-icon)
{
    line-height: 1;
}

.score-badge-complete-text
{
    font-size: 0.75rem;
    font-weight: 600;
    color: var(--cr-splash-accent);
}

.score-badge-star
{
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
}

.score-badge-star :deep(.cr-image)
{
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
}

.score-badge-score
{
    position: relative;
    color: var(--cr-score-badge-text);
    line-height: 1;
}
</style>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';

const { t } = useI18n();

const props = defineProps<
{
    score: number;
    threshold: number;
}>();

const isComplete = computed(() => props.score >= props.threshold);
</script>
